<template>
  <div class="import-choose-method">
    <MaxWidthContainer size="xl">
      <div class="import__intro">
        <h2 class="h1 my-3">{{ $t('Wie möchtest du importieren?') }}</h2>
        <p>{{ $t('Bitte wähle eine Option und klicke auf Weiter.') }}</p>
      </div>
      <div>
        <FormFieldRadioGroup
          variant="no-label"
          inner-container-class="d-flex"
          :checked="importMethod"
          :stacked="false"
          @input="(checked) => $emit('update:importMethod', checked)"
        >
          <FormRadio variant="card" value="eAma">
            <template #image>
              <!-- eslint-disable max-len -->
              <img
                alt="eAMA Logo"
                src="data:image/png;base64,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"
              />
              <!-- eslint-enable max-len -->
            </template>
            <template #default>
              {{ $t('Direkt von eAMA') }}
            </template>
            <template #text>
              {{ $t('Du kannst die Flächen direkt von eAMA mit AMA-Betriebsnummer und AMA-Pin importieren.') }}
            </template>
          </FormRadio>
          <FormRadio variant="card" value="upload">
            <template #image>
              <FontAwesomeIcon icon="cloud-upload" size="3x" class="text-black" />
            </template>
            <template #default>
              <span class="d-block mt-4">
                {{ $t('Datei hochladen') }}
              </span>
            </template>
            <template #text>
              {{
                $t('Du kannst Flächen mit Dateien im Format Shape, XML, KML, XLS, XLSX und CSV hochladen.')
              }}</template
            >
          </FormRadio>
        </FormFieldRadioGroup>
        <Button class="float-right mr-3" @click="$emit('next')">
          {{ $t('Weiter') }}
        </Button>
      </div>
    </MaxWidthContainer>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCloudUpload } from '@fortawesome/pro-solid-svg-icons';

import MaxWidthContainer from '@/shared/components/MaxWidthContainer.vue';
import Button from '@/shared/components/buttons/Button.vue';
import FormFieldRadioGroup from '@/shared/components/form/FormFieldRadioGroup.vue';
import FormRadio from '@/shared/components/form/FormRadio.vue';

library.add(faCloudUpload);

export default {
  name: 'ImportChooseMethod',
  components: {
    MaxWidthContainer,
    FormFieldRadioGroup,
    FormRadio,
    Button,
  },
  props: {
    importMethod: {
      type: String,
      default: 'eAma',
    },
  },
  mounted() {
    this.updateImportNextEnabled();
  },
  watch: {
    importMethod() {
      this.updateImportNextEnabled();
    },
  },
  methods: {
    updateImportNextEnabled() {
      this.$emit('update:importNextEnabled', this.importMethod != null);
    },
  },
};
</script>

<style scoped>
.import-choose-method {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.import__intro {
  margin-top: 20px;
  margin-bottom: 20px;
  text-align: center;
}
</style>
